<template>
  <div class="login-page" dir="rtl">
    <div class="login-glow login-glow-primary" aria-hidden="true"></div>
    <div class="login-glow login-glow-secondary" aria-hidden="true"></div>
    <div class="container-fluid login-surface">
      <nav
        v-if="
          this.$session.get('MenuLog') != null &&
          this.$session.get('MenuLog').length &&
          this.$session.get('MenuLog').length > 0
        "
        class="navbar navbar-expand-lg navbar-dark login-services-nav"
        dir="rtl"
        aria-label="خدمات قابل دسترس بدون ورود"
      >
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarText"
          aria-controls="navbarText"
          aria-expanded="false"
          aria-label="نمایش یا بستن خدمات بدون ورود"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarText">
          <ul class="navbar-nav login-services-list">
            <li
              class="nav-item"
              v-for="item in this.$session.get('MenuLog')"
              :key="item.id"
            >
              <a
                :title="
                  item.routeName == 'DepositPay'
                    ? ' واریز به حساب / پرداخت اقساط از طریق شماره حساب / تسهیلات یا شناسه واریز بدون ورود به سامانه'
                    : ' درخواست افتتاح حساب به صورت غیر حضوری و توسط پرتال'
                "
                class="nav-link login-service-link"
                href="javascript:void(0)"
                @click="GotoDeposit(item)"
                ><i class="ml-2" :class="item.menuIcone" aria-hidden="true"></i
                >{{ item.name }}</a
              >
            </li>
          </ul>
        </div>
      </nav>

      <main v-if="Lock == true" class="login-main">
        <section class="login-card" aria-labelledby="login-title">
          <div class="login-card-body">
            <div class="row no-gutters login-card-layout">
              <div class="col-md-7 col-12 login-form-panel">
                <header class="login-heading">
                  <div class="login-brand-mark" aria-hidden="true">
                    <i class="fas fa-shield-alt"></i>
                  </div>
                  <span class="login-eyebrow">{{
                    $store.state.NameSandogh == null
                      ? "سیستم یکپارچه تحت وب پاسارگاد"
                      : " سامانه خدمات الکترونیکی "
                  }}</span>
                  <h1 id="login-title">
                    {{ $store.state.NameSandogh || "ورود امن به سامانه" }}
                  </h1>
                  <p v-if="stepTwo == false && ChangePass == false">
                    برای دسترسی به خدمات، اطلاعات حساب خود را وارد کنید.
                  </p>
                  <p v-else-if="stepTwo == true">
                    کد تأیید ارسال‌شده را برای تکمیل ورود وارد کنید.
                  </p>
                  <p v-else>
                    برای حفظ امنیت حساب، یک رمز عبور تازه انتخاب کنید.
                  </p>
                </header>
                <article
                  v-if="stepTwo == false && ChangePass == false"
                  class="login-form"
                >
                  <div class="login-field" v-if="!Is2Semat">
                    <label for="UserName">نام کاربری</label>
                    <div class="login-input-wrap">
                      <i
                        class="fa fa-user login-field-icon"
                        aria-hidden="true"
                      ></i>
                      <input
                        class="login-input"
                        @keypress="
                          keypressEnter($event);
                          $BlockSuspiciousInput($event, 30);
                        "
                        @keyup="$BlockSuspiciousInput($event, 30)"
                        id="UserName"
                        type="number"
                        v-model="UserName"
                        placeholder="کد ملی یا نام کاربری"
                        autocomplete="username"
                        inputmode="numeric"
                      />
                    </div>
                  </div>

                  <div class="login-field" v-if="!Is2Semat">
                    <label for="PassWord">رمز عبور</label>
                    <div class="login-input-wrap">
                      <i
                        class="fa fa-key login-field-icon"
                        aria-hidden="true"
                      ></i>
                      <input
                        class="login-input login-password-input"
                        id="PassWord"
                        @keypress="$BlockSuspiciousInput($event, 30)"
                        @keyup="$BlockSuspiciousInput($event, 30)"
                        v-model="Pass"
                        type="password"
                        placeholder="رمز عبور خود را وارد کنید"
                        name="psw"
                        autocomplete="current-password"
                      />
                      <button
                        type="button"
                        class="password-toggle"
                        id="togglePassword"
                        @click="TogglePassword"
                        aria-label="نمایش یا پنهان‌کردن رمز عبور"
                        tabindex="-1"
                      >
                        <i class="fas fa-eye" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                  <button
                    :disabled="loading"
                    id="BtnSubLogin"
                    type="button"
                    class="btn btn-submit"
                    @click="recaptcha"
                  >
                    <span
                      v-show="loading"
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span>{{ this.loadingText }}</span>
                  </button>
                  <div v-if="Is2Semat" class="login-back-action">
                    <a
                      href="javascript:void(0);"
                      @click.prevent="GoToDefultLogin"
                    >
                      بازگشت به ورود معمولی
                    </a>
                  </div>

                  <div class="login-help-links">
                    <div
                      class="d-block d-lg-none login-mobile-service"
                      v-if="
                        $session.get('MenuLog') &&
                        $session.get('MenuLog').length > 0
                      "
                    >
                      <router-link
                        :to="{ name: $session.get('MenuLog')[0].routeName }"
                        >{{ $session.get("MenuLog")[0].name }}</router-link
                      >
                    </div>
                    <div v-if="isremmberpass == true">
                      <router-link :to="{ name: 'Rememberpassword' }"
                        ><i class="fas fa-unlock-alt" aria-hidden="true"></i>
                        رمز عبور را فراموش کرده‌اید؟</router-link
                      >
                    </div>
                  </div>
                </article>
                <article v-if="stepTwo == true" class="login-form otp-form">
                  <div class="otp-label">
                    <i class="fas fa-mobile-alt" aria-hidden="true"></i>
                    <span>کد تأیید ۴ رقمی</span>
                  </div>
                  <div class="otp-inputs" dir="ltr">
                    <div>
                      <input
                        type="text"
                        id="code0"
                        @input="twoStepCode(0)"
                        v-model="codeDigits[0]"
                        class="otp-input"
                        inputmode="numeric"
                        autocomplete="one-time-code"
                        maxlength="1"
                        aria-label="رقم اول کد تأیید"
                      />
                    </div>
                    <div>
                      <input
                        type="text"
                        id="code1"
                        @input="twoStepCode(1)"
                        v-model="codeDigits[1]"
                        class="otp-input"
                        inputmode="numeric"
                        maxlength="1"
                        aria-label="رقم دوم کد تأیید"
                      />
                    </div>
                    <div>
                      <input
                        type="text"
                        id="code2"
                        @input="twoStepCode(2)"
                        v-model="codeDigits[2]"
                        class="otp-input"
                        inputmode="numeric"
                        maxlength="1"
                        aria-label="رقم سوم کد تأیید"
                      />
                    </div>
                    <div>
                      <input
                        type="text"
                        id="code3"
                        @input="twoStepCode(3)"
                        v-model="codeDigits[3]"
                        class="otp-input"
                        inputmode="numeric"
                        maxlength="1"
                        aria-label="رقم چهارم کد تأیید"
                      />
                    </div>
                  </div>
                  <button
                    id="BtnSubLogin"
                    type="button"
                    class="btn btn-submit"
                    :disabled="loading"
                    @click="recaptcha"
                  >
                    <span
                      v-show="loading"
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span>{{ this.loadingText }}</span>
                  </button>
                </article>
                <article class="login-form" v-if="ChangePass == true">
                  <form id="divpass" @submit.prevent="ChangePassFirstLogin">
                    <div class="security-notice">
                      <i class="fas fa-info-circle" aria-hidden="true"></i>
                      <span>
                        رمز امن از حروف بزرگ و کوچک لاتین، عدد و نشانه تشکیل
                        می‌شود.
                      </span>
                    </div>
                    <div class="login-field">
                      <label for="NewPass">رمز عبور جدید</label>
                      <div class="login-input-wrap">
                        <i
                          class="fa fa-key login-field-icon"
                          aria-hidden="true"
                        ></i>
                        <input
                          id="NewPass"
                          class="login-input required required-Pass"
                          type="password"
                          placeholder="رمز عبور جدید"
                          @keypress="$BlockSuspiciousInput($event, 30)"
                          v-model="NewPass"
                          autocomplete="new-password"
                        />
                      </div>
                    </div>
                    <div class="login-field">
                      <label for="ConfirmNewPass">تکرار رمز عبور جدید</label>
                      <div class="login-input-wrap">
                        <i
                          class="fa fa-check login-field-icon"
                          aria-hidden="true"
                        ></i>
                        <input
                          id="ConfirmNewPass"
                          class="login-input required required-Pass"
                          type="password"
                          @keypress="$BlockSuspiciousInput($event, 30)"
                          placeholder="تکرار کلمه عبور جدید"
                          v-model="ConfirmNewPass"
                          autocomplete="new-password"
                        />
                      </div>
                    </div>
                    <button type="submit" class="btn btn-submit">
                      اعمال رمز عبور جدید
                    </button>
                  </form>
                </article>
              </div>

              <aside id="SlidreLogin" class="col-md-5 col-12 login-trust-panel">
                <div class="trust-panel-content">
                  <div class="trust-badge">
                    <i class="fas fa-lock" aria-hidden="true"></i>
                    <span>ورود امن و محافظت‌شده</span>
                  </div>
                  <div class="brand-spectrum" aria-hidden="true">
                    <span></span>
                  </div>
                  <div class="trust-copy">
                    <h2>مدیریت مالی، ساده و مطمئن</h2>
                    <p>
                      اطلاعات ورود خود را در اختیار دیگران قرار ندهید و از
                      دستگاه‌های عمومی برای ورود استفاده نکنید.
                    </p>
                  </div>
                  <div class="trust-status">
                    <span class="trust-status-dot" aria-hidden="true"></span>
                    <span>سامانه خدمات الکترونیکی فعال است</span>
                  </div>
                </div>
              </aside>
            </div>
            <div class="login-meta-bar">
              <div class="login-version">
                <i class="fas fa-server" aria-hidden="true"></i>
                <span>نسخه {{ $store.state.VersionSoftware }}</span>
              </div>
              <nav class="login-footer-links" aria-label="پیوندهای راهنما">
                <a :href="UrlAboutme" target="_blank" rel="noopener noreferrer"
                  >درباره ما</a
                >
                <span v-if="IsFAQ" aria-hidden="true"></span>
                <router-link v-if="IsFAQ" :to="{ name: 'FAQ' }"
                  >پرسش‌های متداول</router-link
                >
              </nav>
            </div>
          </div>
        </section>
      </main>
      <main v-else class="login-main">
        <section class="license-card" role="alert">
          <div class="license-icon" aria-hidden="true">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <h1>اعتبار نرم‌افزار به پایان رسیده است</h1>
          <p>
            مهلت استفاده قانونی از سامانه پایان یافته است. برای تمدید، با واحد
            فروش شرکت پاسارگاد تماس بگیرید.
          </p>
        </section>
      </main>
    </div>
    <div v-for="post in posts" :key="post.id"></div>
    <loading v-if="loadingRender"></loading>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Loading from "../Tools/NetPa/Loading.vue";
export default {
  components: { Loading },
  data() {
    return {
      isremmberpass: false,
      CustomerCode: "",
      loadingRender: false,
      enable: false,
      appsettings: {},
      NewPass: "",
      ConfirmNewPass: "",
      codeDigits: ["", "", "", ""],
      stepTwo: false,
      ChangePass: false,
      Lock: true,
      IsMobileSize: false,
      DataAxios: {
        ArryfildName: ["UserName", "Password"],
        ArryfildValue: ["مدير", "1234"],
        Method: "Post",
        Action: "GetUserData",
      },
      DataAxiosWcf: {
        ArryfildValue: {},
        Method: "Post",
        Action: "Wcf",
      },
      DataAxiosGetGrpMenu: {
        ArryfildValue: "",
        Method: "Get",
        Action: "DefineDastresi/GetbvtblGrpCloudMenu",
        Token: this.$session.get("Token"),
      },
      UserGrpMenu: null,
      UserName: "",
      Pass: "",
      Omid: [],
      IsSHowMenu: "d-none",
      ListName: ["UserName", "Password"],
      ListValue: ["مدير", "1234"],
      Usrtoken: "",
      UserAction: "DefineShobe ",
      UserMethod: "Post",
      loading: false,
      loadingText: " ورود به سامانه ",
      Is2Semat: false,
      ListUserSemat: [],
      ListGetUserData: [],
      ListDB: [],
      IdSelectedSemat: -1,
      IdSelectedDb: -1,
      valComboSemat: -1,
      howManyVerify: 0,
      DataAxiosUpdate: {
        ArryfildValue: {},
        Method: "put",
        Action: "",
        Token: "",
        From: "Body",
      },
      infoNetPa: null,
      CountLogin: 0,
      UrlAboutme: "",
      IsFAQ: false,
      CodeMeli: "",
      RandomKeyLogin: "",
      loginDefaultImageMode: true,
    };
  },
  component: {},

  methods: {
    GetRouterParams() {
      if (this.$route.query.custcode == "948") {
        this.loading = true;
        this.GetAppSetting().then((data) => {
          this.CodeMeli = this.$route.query.u;
          this.RandomKeyLogin = this.$route.query.k;
          this.CustomerCode = this.$route.query.custcode;
          this.LoginWithRandomKey();
        });
      }
    },
    GetAppSetting() {
      return new Promise((success, reject) => {
        var axios = require("axios");
        var config = {
          method: "GET",
          url: "/appSettings.json?nocache=123",
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Content-Type": "application/json",
          },
        };
        axios(config).then((result) => {
          if (
            this.$store.state.VersionSoftware != result.data.VersionSoftware
          ) {
            window.location = window.location.href + "?eraseCache=true";
          } else {
            this.appsettings = result.data;
            success();
            this.gettblCustomer();
          }
        });
      });
    },
    TogglePassword() {
      if (document.getElementById("PassWord").type == "password") {
        document.getElementById("PassWord").type = "text";
      } else {
        document.getElementById("PassWord").type = "password";
      }
    },
    async recaptcha() {
      this.LoginTo();
    },
    GatImg() {
      return 'background-image:url("./Image/back.jpg");background-size: cover; height: 100vh;';
    },
    GetImageMob() {
      return 'background-image:url("./Image/back.jpg");background-size: cover; height: 100vh;';
    },
    twoStepCode(num) {
      if (this.codeDigits[num].length >= 1 && num < 3) {
        this.codeDigits[num].slice(0, 1);
        document.getElementById("code" + (num + 1)).focus();
      } else if (num >= 3) {
        this.LoginTo();
      }
    },
    LoginTo() {
      var axios = require("axios");
      var FormData = require("form-data");
      var data = new FormData();

      if (this.UserName.trim() == "" || this.Pass.trim() == "") {
        let PassWordInput = document.getElementById("PassWord");
        PassWordInput.focus();
        this.$mySweetDefault(
          "هشدار",
          "وارد کرد نام کاربری و کلمه عبور اجباری می باشد .",
          "warning",
          3000,
        );
      } else {
        if (this.UserName.length < 8) {
          this.$mySweetDefault(
            "اطلاع رسانی",
            "طول نام کاربری باید حداقل 8 رقم باشد .",
            "info",
            3000,
          );
        } else {
          try {
            this.CustomerCode =
              this.$route.query.custcode == undefined
                ? this.$session.get("CustCode")
                : this.$route.query.custcode;
            this.loading = true;
            this.loadingText = "درحال بارگذاری ... ";
            data.append("UserName", this.UserName);
            data.append("Pass", this.$Encryption(this.Pass));
            data.append("CustomerCode", this.CustomerCode);
            if (this.stepTwo) {
              var twoStepCode =
                this.codeDigits[0] +
                this.codeDigits[1] +
                this.codeDigits[2] +
                this.codeDigits[3];
              data.append("twoStepCode", twoStepCode);
            }
            var configNetPa = {
              method: "post",
              url: this.$GetapiBase() + "Auth/NetPaLogin",
              headers: {},
              data: data,
            };
            axios(configNetPa)
              .then((resNetpa) => {
                if (resNetpa.data == null) {
                  this.$mySweetDefault(
                    "ورود ناموفق",
                    "نام کاربری و یا کلمه عبور نادرست است",
                    "error",
                    3000,
                  );
                  this.loading = false;
                  this.loadingText = " ورود به سامانه ";
                } else {
                  if (resNetpa.data.status == "success") {
                    if (resNetpa.data.data.id != null) {
                      this.infoNetPa = resNetpa.data.data;
                      this.$session.start();
                      this.$session.set("TokenNetPa", this.infoNetPa.token);
                      this.$session.set("UserInfoNetPa", this.infoNetPa);
                      console.log(
                        "login.vue 1*-*-*-*-*-*-*-*- ",
                        this.$session.get("UserInfoNetPa"),
                      );
                      this.$FetchAzaPic();
                      this.SetAxarinVorodBeSite();

                      //خواندن منوهای فعال برنامه
                      var DataAxiosMenu = {
                        ArryfildValue: "",
                        Method: "Get",
                        Action: "Menu",
                        Token: this.$session.get("TokenNetPa"),
                      };
                      this.$PostData(DataAxiosMenu).then((result) => {
                        this.$session.set("AllMenu", result);

                        //خواندن کل جدول منو برای بررسی دسترسی ها
                        var DataAxiosRead = {
                          ArryfildValue: {},
                          Method: "Post",
                          Action: "Menu/getAllmenus",
                          Token: this.$session.get("TokenNetPa"),
                        };
                        this.$PostData(DataAxiosRead).then((data) => {
                          this.$session.set("AccessMenu", data);
                          if (
                            this.infoNetPa.countAuthFailed >= this.CountLogin ||
                            this.infoNetPa.isLockForLogin == 1
                          ) {
                            var Lock = {
                              ArryfildValue: {},
                              Method: "Put",
                              Action: "AxarinVorod",
                            };
                            const LockData = new FormData();

                            LockData.append("userName", this.UserName);
                            LockData.append("IsLockForLogin", 1);
                            Lock.ArryfildValue = LockData;
                            this.$PostFormData(Lock)
                              .then((data) => {})
                              .finally(() => {
                                this.$mySweetDefault(
                                  "ورود ناموفق",
                                  "به دلیل ورود بیش از حد نام کاربری و کلمه عبور اشتباه، نام کاربری شما مسدود شد",
                                  "error",
                                  3000,
                                );
                                this.loading = false;
                                this.loadingText = " ورود به سامانه ";
                              });
                          } else {
                            var DataAxiosRahbari = {
                              ArryfildValue: "",
                              Method: "POST",
                              Action: "Rahbari",
                              Token: this.$session.get("TokenNetPa"),
                            };
                            var DataAxiosModirShobe = {
                              ArryfildValue: "",
                              Method: "POST",
                              Action: "ModirShobe",
                              Token: this.$session.get("TokenNetPa"),
                            };
                            const RahbariData = new FormData();

                            RahbariData.append(
                              "wwwTblAzaId",
                              this.$session.get("UserInfoNetPa").wwwtblAzaId +
                                "",
                            );
                            RahbariData.append(
                              "wwwtblShobeId",
                              this.$session.get("UserInfoNetPa").wwwtblShobeId +
                                "",
                            );
                            DataAxiosRahbari.ArryfildValue = RahbariData;
                            this.$PostFormData(DataAxiosRahbari)
                              .then((res) => {
                                if (res.length > 0) {
                                  this.$session.set("IsRahbar", true);
                                } else {
                                  this.$session.set("IsRahbar", false);
                                }
                              })
                              .finally(() => {
                                const ModirShobe = new FormData();
                                ModirShobe.append(
                                  "wwwTblAzaId",
                                  this.$session.get("UserInfoNetPa")
                                    .wwwtblAzaId + "",
                                );
                                ModirShobe.append(
                                  "wwwtblShobeId",
                                  this.$session.get("UserInfoNetPa")
                                    .wwwtblShobeId + "",
                                );
                                DataAxiosModirShobe.ArryfildValue = RahbariData;
                                this.$PostFormData(DataAxiosModirShobe)
                                  .then((res) => {
                                    if (res.length > 0) {
                                      this.$session.set("ModirShobe", true);
                                    } else {
                                      this.$session.set("ModirShobe", false);
                                    }
                                  })
                                  .finally(() => {
                                    if (this.$session.get("UserInfoNetPa").id) {
                                      if (
                                        resNetpa.data.user &&
                                        resNetpa.data.user.webPss
                                      ) {
                                        this.$router.push(
                                          "/PishkhanNetPa/Home",
                                        );
                                      } else {
                                        if (
                                          this.$session.get("UserInfoNetPa")
                                            .isHasBeenChangedPassFirstLogin
                                        ) {
                                          this.ChangePass = true;
                                        } else {
                                          this.$router.push(
                                            "/PishkhanNetPa/Home",
                                          );
                                        }
                                      }
                                    }
                                  });
                              });
                          }
                        });
                      });
                    } else {
                      this.$mySweetDefault(
                        "ورود ناموفق",
                        "نام کاربری و یا کلمه عبور نادرست است",
                        "error",
                        3000,
                      );
                      this.loading = false;
                      this.loadingText = " ورود به سامانه ";
                    }
                  } else if (resNetpa.data.status == "successTwoStep") {
                    this.$mySweetDefault(
                      "پیام سیستم",
                      resNetpa.data.msg,
                      "info",
                      3000,
                    );
                    this.loading = false;
                    this.stepTwo = true;
                    this.$nextTick(() => {
                      this.loadingText = " ورود به سامانه ";
                      var el = document.getElementById("code0");
                      el.focus();
                    });
                  } else if (resNetpa.data.status == "failStep") {
                    this.$mySweetDefault(
                      "پیام سیستم",
                      resNetpa.data.msg,
                      "error",
                      3000,
                    );
                    this.loading = false;
                    this.loadingText = " ورود به سامانه ";
                  } else if (resNetpa.data.status == "fail") {
                    this.$mySweetDefault(
                      "خطا",
                      resNetpa.data.msg,
                      "error",
                      3000,
                    );
                  }
                }
              })
              .finally(() => {})
              .catch(function (error) {
                console.log(error);
                this.loading = false;
                this.loadingText = " ورود به سامانه ";
              });
          } catch (error) {
            this.loading = false;
            this.loadingText = " ورود به سامانه ";
          }
        }
      }
    },
    LoginWithRandomKey() {
      var axios = require("axios");
      var FormData = require("form-data");
      var data = new FormData();

      try {
        this.CustomerCode =
          this.$route.query.custcode == undefined
            ? this.$session.get("CustCode")
            : this.$route.query.custcode;
        this.loading = true;
        this.loadingText = "درحال بارگذاری ... ";
        data.append("Username", this.CodeMeli);
        data.append("LoginKey", this.RandomKeyLogin);

        var configNetPa = {
          method: "post",
          url: this.$GetapiBase() + "Auth/NetPaLoginKey",
          headers: {},
          data: data,
        };
        axios(configNetPa)
          .then((resNetpa) => {
            if (resNetpa.data == null) {
              this.$mySweetDefault(
                "ورود ناموفق",
                "نام کاربری و یا کلمه عبور نادرست است",
                "error",
                3000,
              );
              this.loading = false;
              this.loadingText = " ورود به سامانه ";
            } else {
              if (resNetpa.data.status == "success") {
                if (resNetpa.data.data.id != null) {
                  this.infoNetPa = resNetpa.data.data;
                  this.$session.start();
                  this.$session.set("TokenNetPa", this.infoNetPa.token);
                  this.$session.set("UserInfoNetPa", this.infoNetPa);
                  console.log(
                    "login.vue 2*-*-*-*-*-*-*-*- ",
                    this.$session.get("UserInfoNetPa"),
                  );
                  this.$FetchAzaPic();
                  this.SetAxarinVorodBeSite();

                  //خواندن منوهای فعال برنامه
                  var DataAxiosMenu = {
                    ArryfildValue: "",
                    Method: "Get",
                    Action: "Menu",
                    Token: this.$session.get("TokenNetPa"),
                  };
                  this.$PostData(DataAxiosMenu).then((result) => {
                    this.$session.set("AllMenu", result);

                    //خواندن کل جدول منو برای بررسی دسترسی ها
                    var DataAxiosRead = {
                      ArryfildValue: {},
                      Method: "Post",
                      Action: "Menu/getAllmenus",
                      Token: this.$session.get("TokenNetPa"),
                    };
                    this.$PostData(DataAxiosRead).then((data) => {
                      this.$session.set("AccessMenu", data);
                      if (
                        this.infoNetPa.countAuthFailed >= this.CountLogin ||
                        this.infoNetPa.isLockForLogin == 1
                      ) {
                        var Lock = {
                          ArryfildValue: {},
                          Method: "Put",
                          Action: "AxarinVorod",
                        };
                        const LockData = new FormData();

                        LockData.append("userName", this.UserName);
                        LockData.append("IsLockForLogin", 1);
                        Lock.ArryfildValue = LockData;
                        this.$PostFormData(Lock)
                          .then((data) => {})
                          .finally(() => {
                            this.$mySweetDefault(
                              "ورود ناموفق",
                              "به دلیل ورود بیش از حد نام کاربری و کلمه عبور اشتباه، نام کاربری شما مسدود شد",
                              "error",
                              3000,
                            );
                            this.loading = false;
                            this.loadingText = " ورود به سامانه ";
                          });
                      } else {
                        var DataAxiosRahbari = {
                          ArryfildValue: "",
                          Method: "POST",
                          Action: "Rahbari",
                          Token: this.$session.get("TokenNetPa"),
                        };
                        var DataAxiosModirShobe = {
                          ArryfildValue: "",
                          Method: "POST",
                          Action: "ModirShobe",
                          Token: this.$session.get("TokenNetPa"),
                        };
                        const RahbariData = new FormData();

                        RahbariData.append(
                          "wwwTblAzaId",
                          this.$session.get("UserInfoNetPa").wwwtblAzaId + "",
                        );
                        RahbariData.append(
                          "wwwtblShobeId",
                          this.$session.get("UserInfoNetPa").wwwtblShobeId + "",
                        );
                        DataAxiosRahbari.ArryfildValue = RahbariData;
                        this.$PostFormData(DataAxiosRahbari)
                          .then((res) => {
                            if (res.length > 0) {
                              this.$session.set("IsRahbar", true);
                            } else {
                              this.$session.set("IsRahbar", false);
                            }
                          })
                          .finally(() => {
                            const ModirShobe = new FormData();
                            ModirShobe.append(
                              "wwwTblAzaId",
                              this.$session.get("UserInfoNetPa").wwwtblAzaId +
                                "",
                            );
                            ModirShobe.append(
                              "wwwtblShobeId",
                              this.$session.get("UserInfoNetPa").wwwtblShobeId +
                                "",
                            );
                            DataAxiosModirShobe.ArryfildValue = RahbariData;
                            this.$PostFormData(DataAxiosModirShobe)
                              .then((res) => {
                                if (res.length > 0) {
                                  this.$session.set("ModirShobe", true);
                                } else {
                                  this.$session.set("ModirShobe", false);
                                }
                              })
                              .finally(() => {
                                if (this.$session.get("UserInfoNetPa").id) {
                                  if (
                                    resNetpa.data.user &&
                                    resNetpa.data.user.webPss
                                  ) {
                                    this.$router.push("/PishkhanNetPa/Home");
                                  } else {
                                    if (
                                      this.$session.get("UserInfoNetPa")
                                        .isHasBeenChangedPassFirstLogin
                                    ) {
                                      this.ChangePass = true;
                                    } else {
                                      this.$router.push("/PishkhanNetPa/Home");
                                    }
                                  }
                                }
                              });
                          });
                      }
                    });
                  });
                } else {
                  this.$mySweetDefault(
                    "ورود ناموفق",
                    "نام کاربری و یا کلمه عبور نادرست است",
                    "error",
                    3000,
                  );
                  this.loading = false;
                  this.loadingText = " ورود به سامانه ";
                }
              } else if (resNetpa.data.status == "successTwoStep") {
                this.$mySweetDefault(
                  "پیام سیستم",
                  resNetpa.data.msg,
                  "info",
                  3000,
                );
                this.loading = false;
                this.stepTwo = true;
                this.$nextTick(() => {
                  this.loadingText = " ورود به سامانه ";
                  var el = document.getElementById("code0");
                  el.focus();
                });
              } else if (resNetpa.data.status == "failStep") {
                this.$mySweetDefault(
                  "پیام سیستم",
                  resNetpa.data.msg,
                  "error",
                  3000,
                );
                this.loading = false;
                this.loadingText = " ورود به سامانه ";
              } else if (resNetpa.data.status == "fail") {
                this.$mySweetDefault("خطا", resNetpa.data.msg, "error", 3000);
              }
            }
          })
          .finally(() => {})
          .catch(function (error) {
            console.log(error);
            this.loading = false;
            this.loadingText = " ورود به سامانه ";
          });
      } catch (error) {
        this.loading = false;
        this.loadingText = " ورود به سامانه ";
      }
    },
    GetLockData() {
      this.$store.state.loadingRender = true;
      this.$PostData(this.DataAxiosWcf)
        .then((response) => {
          this.$store.state.loadingRender = false;
          this.$session.set("Lock", response);
          this.$store.state.NameSandogh = response.b_CustomerName;
        })
        .catch((error) => {
          this.$store.state.loadingRender = false;
          console.log(error);
        });
    },
    GoToDefultLogin() {
      this.IdSelectedSemat = -1;
      this.Is2Semat = false;
      this.valComboSemat = -1;
      this.loading = false;
      this.loadingText = " ورود به سامانه ";
    },
    Visibel() {
      if (this.IsSHowMenu == "d-none") {
        this.IsSHowMenu = "";
      } else {
        this.IsSHowMenu = "d-none";
      }
    },
    Menu(ThemeMenu) {
      if (ThemeMenu == "Nav") {
        this.$session.start();
        this.$session.set("MenuTheme", "Nav");
      }
      if (ThemeMenu == "Riboon") {
        this.$session.set("MenuTheme", "Riboon");
      }
    },
    keypressEnter(evn) {
      if (evn.code == "Enter") {
        if (evn.target.id == "UserName") {
          let PassWordInput = document.getElementById("PassWord");
          PassWordInput.focus();
        }
      }
    },
    SetAxarinVorodBeSite() {
      var UserIp;
      this.$GetipClient().then((data) => {
        UserIp = data.data.ip;
        var DataAxios_AxrinVorod = {
          ArryfildValue: "",
          Method: "POST",
          Action: "AxarinVorod/AxarinVorod_V2/",
          Token: this.$session.get("TokenNetPa"),
        };
        const AxarinVorod = new FormData();
        AxarinVorod.append(
          "wwwTblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        AxarinVorod.append(
          "wwwtblShobeId",
          this.$session.get("UserInfoNetPa").wwwtblShobeId,
        );
        AxarinVorod.append(
          "AxarinVorodBeSite",
          this.$store.state.JalaliDateAndTime,
        );
        AxarinVorod.append("IpAddress", UserIp);
        AxarinVorod.append("MacAddress", "");
        AxarinVorod.append("IsLogin", true);
        DataAxios_AxrinVorod.ArryfildValue = AxarinVorod;
        this.$PostFormData(DataAxios_AxrinVorod);
      });
    },
    gettblCustomer() {
      this.loading = true;
      this.loadingText = "لطفا منتظر بمانید ...";

      var settings = {
        method: "Post",
        url: this.$GetapiBase() + "Setting",
        headers: {},
        data: null,
      };
      var axios = require("axios");
      axios(settings)
        .then((result) => {
          this.CountLogin = result.data.countAuth;

          this.$PostData({
            ArryfildValue: {},
            Action: "GetTblCustomer",
            method: "GET",
            Token: "",
          })
            .then((data) => {
              this.$SetActivePasswordSecurityMode(
                data.activePasswordSecurityMode,
              );
              this.loginDefaultImageMode = data.loginDefaultImageMode;
              this.$setLoginImgMode(data.loginDefaultImageMode);

              let CustomerName = data.name;
              if (data.custCode == 561) {
                this.$store.state.NameSandogh = "صندوق قرض الحسنه";
                this.$session.set("NameSandogh", "صندوق قرض الحسنه");
                CustomerName = "صندوق قرض الحسنه";
              } else {
                this.$store.state.NameSandogh = data.name;
                this.$session.set("NameSandogh", data.name);
                let word = "تعاونی";
                if (CustomerName.indexOf(word) !== -1) {
                  this.$session.set("IsTaavoniEtebar", true);
                } else {
                  this.$session.set("IsTaavoniEtebar", false);
                }
              }
              this.$session.set("CustCode", data.custCode);
              document.title = " خدمات الکترونیکی " + data.name;
              this.loading = false;
              this.isremmberpass = true;
              this.loadingText = " ورود به سامانه";
              this.CheckupLinkPay();
            })
            .catch((e) => {})
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    GotoDeposit(menuItem) {
      this.$router.push({
        name: menuItem.routeName,
      });
    },
    ReadMenu() {
      var DataAxiosMenu = {
        ArryfildValue: "",
        Method: "post",
        Action: "Menu/GetMenusLogin",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostData(DataAxiosMenu)
        .then((result) => {
          this.$session.set("MenuLog", result);
          // this.updated();
        })
        .catch(() => {
          this.ReadMenu();
        });
    },
    ChangePassFirstLogin() {
      if (this.$ValidForm("divpass")) {
        if (
          this.NewPass == this.ConfirmNewPass &&
          this.NewPass.length > 4 &&
          this.ConfirmNewPass.length > 4
        ) {
          var DataAxiosRow = {
            ArryfildValue: "",
            Method: "Post",
            Action: "Auth/ChangePassFirstLogin",
            Token: this.$session.get("TokenNetPa"),
          };
          const formData = new FormData();
          formData.append(
            "wwwtblAzaId",
            this.$session.get("UserInfoNetPa").wwwtblAzaId,
          );
          formData.append("NewPass", this.NewPass);
          formData.append("CustomerCode", this.$session.get("CustCode"));
          formData.append(
            "CodeMeli",
            this.$session.get("UserInfoNetPa").codeMeli,
          );
          formData.append("OldPass", this.$session.get("UserInfoNetPa").webPss);
          formData.append("AxarinTaghirPass", this.$GetJalaliDate());

          DataAxiosRow.ArryfildValue = formData;
          this.$PostFormData(DataAxiosRow).then((data) => {
            if (data.status == "success") {
              this.$mySweetDefault(
                "عملیات موفق",
                "تغییر رمز با موفقیت انجام شد ",
                "succrss",
                3000,
              );
              this.ChangePass = false;
              this.loading = false;
              this.loadingText = " ورود به سامانه ";
            }
          });
        } else {
          this.$mySweetDefaultTost(
            "عملیات ناموفق",
            "کلمه عبور شما باید بیشتر از 4 کارکتر باشد و باید باهم برابر باشند",
            "error",
            3500,
          );
        }
      }
    },
    CheckupLinkPay() {
      this.$GetAppsettings();
      if (this.$route.query.sh) {
        if (Number(this.$route.query.sh) > 0 && this.$route.query.sh != null) {
          this.loadingRender = true;
          this.$router.push({ name: "v", query: { sh: this.$route.query.sh } });
        } else {
        }
      } else {
      }
    },
  },
  mounted() {
    this.$GetAppsettingsAsync().then((IsMaintenance) => {
      if (IsMaintenance == true) {
        this.$router.push({ name: "Maintenance" });
      } else {
        this.$store.state.loadingRender = false;
        this.UrlAboutme = this.appsettings.UrlAboutme;
        this.IsFAQ = this.appsettings.IsFAQ === true;
        let PassWordInput = document.getElementById("UserName");
        PassWordInput.focus();

        let bootstrap = document.createElement("script");
        bootstrap.setAttribute(
          "src",
          "/Template/NewMenu/js/bootstrap.bundle.js",
        );
        document.head.appendChild(bootstrap);

        let custom = document.createElement("script");
        custom.setAttribute("src", "/Template/NewMenu/build/js/custom.js");
        document.head.appendChild(custom);
        this.gettblCustomer();
        this.ReadMenu();

        var ver = localStorage.getItem("VersionSoftware");

        if (ver == null) {
          localStorage.setItem(
            "VersionSoftware",
            this.$store.state.VersionSoftware,
          );
        } else {
          var OldVer = localStorage.getItem("VersionSoftware");
          var NewVer = this.$store.state.VersionSoftware;
          if (OldVer != NewVer) {
            localStorage.setItem(
              "VersionSoftware",
              this.$store.state.VersionSoftware,
            );
            this.$swal({
              title: "بروزرسانی جدید",
              text: "نسخه جدید در دسترس میباشد ، لطفا تایید نمایید تا نسخه شما بروزرسانی شود",
              icon: "success",
              position: "center",
              confirmButtonText: "تایید",
              showConfirmButton: true,
              showCancelButton: false,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload(true);
                this.GetRouterParams();
              }
            });
          } else {
            this.GetRouterParams();
          }
        }
      }
    });
  },

  computed: {
    ...mapState(["posts"]),
    Visibelity() {
      return this.IsSHowMenu;
    },
    Sematha: {
      get() {
        return this.valComboSemat;
      },
      set(value) {
        this.valComboSemat = value;
        this.ListDB = [];
        for (let index = 0; index < this.ListUserSemat.length; index++) {
          const element = this.ListUserSemat[index].dbGrpId;
          if (element == value.dbGrpId) {
            this.IdSelectedSemat = index;
          }
        }

        var ListSemahaDb = value;
        var IdSematSelected = ListSemahaDb.tblGrpId;

        this.ListGetUserData.forEach((element) => {
          if (element.tblGrpId == IdSematSelected) {
            this.ListDB.push(element);
          }
        });
      },
    },
    Db: {
      get() {
        return this.IdSelectedDb;
      },
      set(value) {
        this.IdSelectedDb = value;
      },
    },
  },
  created() {
    this.$session.set("ForceLoginpage", false);

    var axios = require("axios");
    var config = {
      method: "GET",
      url: "/appSettings.json?nocache=123",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        "Content-Type": "application/json",
      },
    };
    axios(config).then((result) => {
      if (this.$store.state.VersionSoftware != result.data.VersionSoftware) {
        window.location = window.location.href + "?eraseCache=true";
      } else {
        this.appsettings = result.data;
        this.gettblCustomer();
      }
    });
    this.$GetAppsettings();

    this.Lock = true;
    this.$session.set("Lock", true);
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0,
    );
    if (vw < 420) {
      this.IsMobileSize = true;
    }
    this.$session.set("MenuTheme", "");
  },
};
</script>

<style scoped>
.login-page {
  --login-navy: #29345f;
  --login-navy-soft: #56508d;
  --login-teal: #05b8c8;
  --login-teal-dark: #287db4;
  --login-mint: #edf7fb;
  --login-purple: #8d58a4;
  --login-ink: #13243a;
  --login-muted: #6b7b8e;
  --login-line: #dbe5eb;
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  color: var(--login-ink);
  background: radial-gradient(
      circle at 12% 12%,
      rgba(5, 184, 200, 0.13),
      transparent 28%
    ),
    radial-gradient(
      circle at 88% 88%,
      rgba(141, 88, 164, 0.12),
      transparent 30%
    ),
    linear-gradient(145deg, #f8fbfc 0%, #eef5f6 48%, #f8fafc 100%);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

.login-page::before {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  content: "";
  opacity: 0.38;
  background-image: linear-gradient(
      rgba(15, 39, 68, 0.025) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(15, 39, 68, 0.025) 1px, transparent 1px);
  background-size: 32px 32px;
  mask-image: linear-gradient(to bottom, black, transparent 80%);
}

.login-glow {
  position: fixed;
  z-index: 0;
  width: 360px;
  height: 360px;
  pointer-events: none;
  border-radius: 50%;
  filter: blur(2px);
}

.login-glow-primary {
  top: -190px;
  right: -130px;
  background: rgba(5, 184, 200, 0.12);
}

.login-glow-secondary {
  bottom: -220px;
  left: -120px;
  background: rgba(141, 88, 164, 0.1);
}

.login-surface {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 0 28px 28px;
}

.login-services-nav {
  width: min(1080px, 100%);
  min-height: 64px;
  margin: 0 auto;
  padding: 10px 0;
  background: transparent !important;
}

.login-services-nav .navbar-toggler {
  margin-right: auto;
  padding: 7px 10px;
  border-color: rgba(15, 39, 68, 0.22);
  background: var(--login-navy);
  border-radius: 10px;
}

.login-services-list {
  gap: 8px;
}

.login-service-link {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  padding: 8px 14px !important;
  color: var(--login-navy) !important;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid rgba(15, 39, 68, 0.09);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.72);
  transition: color 180ms ease, border-color 180ms ease, transform 180ms ease;
}

.login-service-link:hover,
.login-service-link:focus-visible {
  color: var(--login-teal-dark) !important;
  border-color: rgba(5, 184, 200, 0.45);
  text-decoration: none;
  transform: translateY(-1px);
}

.login-main {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 30px 0;
}

.login-card {
  position: relative;
  width: min(1060px, 100%);
  overflow: hidden;
  border: 1px solid rgba(15, 39, 68, 0.08);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 30px 80px rgba(15, 39, 68, 0.13),
    0 8px 24px rgba(15, 39, 68, 0.06);
  backdrop-filter: blur(14px);
}

.login-card-body {
  overflow: hidden;
}

.login-card-layout {
  min-height: 650px;
}

.login-form-panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px 64px 36px;
  background: rgba(255, 255, 255, 0.98);
}

.login-heading {
  margin-bottom: 28px;
  text-align: right;
}

.login-brand-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 18px;
  color: #fff;
  font-size: 20px;
  border-radius: 15px;
  background: linear-gradient(145deg, var(--login-teal), var(--login-purple));
  box-shadow: 0 10px 26px rgba(107, 91, 169, 0.28);
}

.login-eyebrow {
  display: block;
  margin-bottom: 8px;
  color: var(--login-teal-dark);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.1px;
}

.login-heading h1 {
  margin: 0 0 10px;
  color: var(--login-navy);
  font-size: clamp(22px, 2.5vw, 30px);
  font-weight: 800;
  line-height: 1.45;
}

.login-heading p {
  margin: 0;
  color: var(--login-muted);
  font-size: 14px;
  line-height: 1.9;
}

.login-form {
  width: 100%;
}

.login-field {
  margin-bottom: 18px;
  text-align: right;
}

.login-field label {
  display: block;
  margin-bottom: 8px;
  color: #31465f;
  font-size: 13px;
  font-weight: 700;
}

.login-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.login-field-icon {
  position: absolute;
  right: 17px;
  z-index: 2;
  width: 18px;
  color: #8091a3;
  font-size: 14px;
  text-align: center;
  pointer-events: none;
}

.login-input {
  width: 100%;
  height: 52px;
  padding: 0 48px;
  color: var(--login-ink);
  font-family: inherit;
  font-size: 14px;
  text-align: center;
  direction: rtl;
  border: 1px solid var(--login-line);
  border-radius: 14px;
  outline: none;
  background: #f9fbfc;
  transition: border-color 180ms ease, box-shadow 180ms ease,
    background 180ms ease;
}

.login-input::placeholder {
  color: #99a6b4;
}

.login-input:hover {
  border-color: #bdcbd4;
}

.login-input:focus {
  border-color: var(--login-teal);
  background: #fff;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.13);
}

.login-input[type="number"] {
  direction: ltr;
  text-align: center;
  -moz-appearance: textfield;
}

.login-input[type="number"]::-webkit-inner-spin-button,
.login-input[type="number"]::-webkit-outer-spin-button {
  margin: 0;
  -webkit-appearance: none;
}

.login-password-input {
  padding-left: 48px;
}

.password-toggle {
  position: absolute;
  left: 8px;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  color: #718296;
  border: 0;
  border-radius: 10px;
  outline: none;
  background: transparent;
  cursor: pointer;
  transition: color 180ms ease, background 180ms ease;
}

.password-toggle:hover {
  color: var(--login-teal-dark);
  background: var(--login-mint);
}

.password-toggle:focus-visible {
  color: var(--login-teal-dark);
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.btn-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  width: 100%;
  min-height: 52px;
  margin-top: 8px;
  padding: 10px 22px;
  color: #fff !important;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  border: 0;
  border-radius: 14px;
  outline: none;
  background: linear-gradient(
    110deg,
    var(--login-navy),
    var(--login-navy-soft) 58%,
    var(--login-purple)
  );
  box-shadow: 0 12px 24px rgba(15, 39, 68, 0.18);
  transition: transform 180ms ease, box-shadow 180ms ease, opacity 180ms ease;
}

.btn-submit:not(:disabled):hover {
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 16px 30px rgba(15, 39, 68, 0.24);
}

.btn-submit:focus-visible {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.22),
    0 12px 24px rgba(15, 39, 68, 0.18);
}

.btn-submit:disabled {
  cursor: wait;
  opacity: 0.68;
}

.login-help-links,
.login-back-action {
  margin-top: 20px;
  text-align: center;
}

.login-help-links > div + div {
  margin-top: 10px;
}

.login-help-links a,
.login-back-action a {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--login-teal-dark);
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
}

.login-help-links a:hover,
.login-back-action a:hover {
  color: var(--login-navy);
  text-decoration: none;
}

.otp-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  margin-bottom: 20px;
  color: #31465f;
  font-size: 13px;
  font-weight: 700;
}

.otp-label i {
  color: var(--login-teal);
}

.otp-inputs {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin: 0 auto 22px;
}

.otp-input {
  width: 58px;
  height: 62px;
  padding: 0;
  color: var(--login-navy);
  font-family: inherit;
  font-size: 24px;
  font-weight: 800;
  text-align: center;
  border: 1px solid var(--login-line);
  border-radius: 14px;
  outline: none;
  background: #f9fbfc;
  caret-color: var(--login-teal);
  transition: border-color 180ms ease, box-shadow 180ms ease,
    transform 180ms ease;
}

.otp-input:focus {
  border-color: var(--login-teal);
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.13);
  transform: translateY(-2px);
}

.security-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 20px;
  padding: 13px 14px;
  color: #415b77;
  font-size: 12px;
  line-height: 1.8;
  border: 1px solid #cde7ed;
  border-radius: 13px;
  background: linear-gradient(135deg, #f0fafc, #f5f1f9);
}

.security-notice i {
  margin-top: 5px;
  color: var(--login-teal);
}

.login-footer-links {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.login-footer-links a {
  color: var(--login-muted);
  font-size: 12px;
  text-decoration: none;
  transition: color 180ms ease;
}

.login-footer-links a:hover,
.login-footer-links a:focus-visible {
  color: var(--login-teal-dark);
  text-decoration: none;
}

.login-footer-links > span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #c2cdd5;
}

.login-trust-panel {
  position: relative;
  overflow: hidden;
  padding: 0;
  color: #fff;
  background: radial-gradient(
      circle at 15% 20%,
      rgba(5, 184, 200, 0.24),
      transparent 28%
    ),
    radial-gradient(
      circle at 90% 75%,
      rgba(141, 88, 164, 0.25),
      transparent 34%
    ),
    linear-gradient(155deg, #4a4584 0%, var(--login-navy) 62%, #20254c 100%);
}

.login-trust-panel::before,
.login-trust-panel::after {
  position: absolute;
  content: "";
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 50%;
}

.login-trust-panel::before {
  top: -120px;
  left: -140px;
  width: 360px;
  height: 360px;
}

.login-trust-panel::after {
  right: -90px;
  bottom: -120px;
  width: 280px;
  height: 280px;
}

.trust-panel-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  min-height: 650px;
  padding: 40px;
}

.trust-badge {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  color: #eefaff;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.07);
  backdrop-filter: blur(8px);
}

.trust-badge i {
  color: #42d5df;
}

.brand-spectrum {
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  margin: 26px 0;
}

.brand-spectrum::before,
.brand-spectrum::after,
.brand-spectrum span {
  position: absolute;
  content: "";
  border-radius: 50%;
}

.brand-spectrum::before {
  width: 178px;
  height: 178px;
  border: 28px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08),
    0 24px 60px rgba(7, 12, 39, 0.24);
}

.brand-spectrum::after {
  width: 122px;
  height: 122px;
  border: 18px solid transparent;
  border-top-color: #8d58a4;
  border-right-color: #5379bd;
  border-bottom-color: #05b8c8;
  transform: rotate(25deg);
  filter: drop-shadow(0 12px 18px rgba(8, 16, 48, 0.25));
}

.brand-spectrum span {
  z-index: 2;
  width: 46px;
  height: 46px;
  background: linear-gradient(145deg, #3cb9dd, #7260ae);
  box-shadow: 0 0 0 9px rgba(255, 255, 255, 0.08),
    0 10px 28px rgba(5, 184, 200, 0.25);
}

.trust-copy {
  text-align: right;
}

.trust-copy h2 {
  margin: 0 0 12px;
  color: #fff;
  font-size: 23px;
  font-weight: 800;
  line-height: 1.6;
}

.trust-copy p {
  margin: 0;
  color: rgba(232, 242, 248, 0.76);
  font-size: 12px;
  line-height: 2;
}

.trust-status {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  padding-top: 18px;
  color: rgba(232, 242, 248, 0.72);
  font-size: 11px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.trust-status-dot {
  width: 8px;
  height: 8px;
  border: 2px solid rgba(66, 213, 223, 0.35);
  border-radius: 50%;
  background: #42d5df;
  box-shadow: 0 0 0 4px rgba(66, 213, 223, 0.1);
}

.login-meta-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 46px;
  padding: 8px 18px;
  border-top: 1px solid #e8eef2;
  background: #fbfcfd;
}

.login-version {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #9aa8b5;
  font-size: 10px;
  direction: rtl;
}

.license-card {
  width: min(560px, 100%);
  padding: 50px 42px;
  text-align: center;
  border: 1px solid #f0d4d1;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 28px 70px rgba(89, 34, 30, 0.12);
}

.license-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 62px;
  margin-bottom: 20px;
  color: #b44f46;
  font-size: 24px;
  border-radius: 18px;
  background: #fcefed;
}

.license-card h1 {
  margin-bottom: 14px;
  color: #713832;
  font-size: 24px;
  font-weight: 800;
}

.license-card p {
  margin: 0;
  color: #7c6866;
  font-size: 14px;
  line-height: 2;
}

@media (max-width: 991.98px) {
  .login-form-panel {
    padding: 42px 38px 34px;
  }

  .trust-panel-content {
    padding: 34px 28px;
  }

  .brand-spectrum {
    min-height: 190px;
  }
}

@media (max-width: 767.98px) {
  .login-surface {
    padding: 0 18px 22px;
  }

  .login-services-nav {
    min-height: 56px;
  }

  .login-services-list {
    padding: 10px 0 0;
  }

  .login-service-link {
    width: 100%;
    margin-bottom: 6px;
  }

  .login-main {
    align-items: flex-start;
    padding: 18px 0 30px;
  }

  .login-card {
    width: min(540px, 100%);
    border-radius: 22px;
  }

  .login-card-layout {
    min-height: auto;
  }

  .login-form-panel {
    min-height: 610px;
    padding: 38px 30px 34px;
  }

  .login-heading {
    margin-bottom: 24px;
  }

  #SlidreLogin {
    display: none;
  }

  .login-meta-bar {
    min-height: 48px;
    padding-right: 16px;
    padding-left: 16px;
  }
}

@media (max-width: 479.98px) {
  .login-surface {
    padding-right: 12px;
    padding-bottom: 0;
    padding-left: 12px;
  }

  .login-main {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .login-form-panel {
    min-height: calc(100vh - 92px);
    padding: 30px 20px 34px;
  }

  .login-brand-mark {
    width: 44px;
    height: 44px;
    margin-bottom: 14px;
    border-radius: 13px;
  }

  .login-heading h1 {
    font-size: 21px;
  }

  .login-heading p {
    font-size: 13px;
  }

  .login-input,
  .btn-submit {
    min-height: 50px;
  }

  .otp-inputs {
    gap: 8px;
  }

  .otp-input {
    width: 52px;
    height: 58px;
  }

  .login-meta-bar {
    gap: 12px;
    padding-right: 12px;
    padding-left: 12px;
  }

  .login-footer-links {
    gap: 8px;
  }

  .login-footer-links a {
    font-size: 11px;
  }

  .license-card {
    padding: 38px 22px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .login-page *,
  .login-page *::before,
  .login-page *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}
</style>
